<template>
  <div id="app">

    <Header v-if="$route.path.indexOf('admin') == -1"></Header>
    <router-view />
    <Logout></Logout>

  </div>
</template>
<script>
export default {
  name: 'App',
  components: {
  },
  mounted() {
  }
}
</script>
<style>
</style>
<!-- Custom fonts for this template-->
<style src="../static/vendor/fontawesome-free/css/all.min.css" rel="stylesheet" type="text/css"></style>

<!-- Bootstrap core JavaScript-->



// WEBPACK FOOTER //
// src/App.vue